import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import { startApp } from './ui/app';

startApp(document.getElementById('app')!);
